import myStores from './myStores';
import addStore from './addStore';
import StoreDetails from './details';
import storeFeedback from './storeFeedback';
import VoucherDetails from './pendingVoucherDetails';

export default [
  myStores,
  addStore,
  StoreDetails,
  storeFeedback,
  VoucherDetails,
];
